import { frontendCurrency } from "utils/formatCurrency"

export const ColoredNumber = (number: number) => {
  return (
    <span
      className={`${
        number > 0 ? "tw-text-success" : number < 0 ? "tw-text-danger" : ""
      }`}
    >
      {frontendCurrency(number)}
    </span>
  )
}
